function toastProp(message, type) {
    return {
      render: message,
      type: type ? "success" : "error",
      isLoading: false,
      autoClose: 2500,
      closeOnClick: true,
      draggable: true,
      pauseOnHover: false,
      pauseOnFocusLoss: false,
      theme: "light",
    };
  }
  export default toastProp;